module.exports = __webpack_public_path__ + "870aa21499e308a1d300e4fea3623642.svg";